import React, { useState } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import mapIcon from "../images/mapIcon.svg";
import wine from "../images/similarwine/chelsea-pridham-MMOXoxE_Gj0-unsplash.png";
import "./styles/GoogleMaps.css";
import dicertionVector from "../images/direction-vector.svg";

const libraries = ["places"];

export default function GoogleMaps({ wineryDetailInfo }) {
  const mapContainerStyle = {
    width: "100%",
    height: "80vh",
  };
  let center = { lat: 0, lng: 0 };

  if (wineryDetailInfo && wineryDetailInfo.location) {
    const { lat, lng } = wineryDetailInfo.location;
    if (!isNaN(lat) && !isNaN(lng)) {
      center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };
    }
  }

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAP7_Dlc7qRZaIGbqEupCR3Kl8TLaNptOo",
    libraries,
  });

  const [selected, setSelected] = useState(null);

  if (loadError) return "Error loading maps";
  if (!isLoaded)
    return (
      <div className="loarder-cont">
        <div className="loader">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
    );

  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={15}
        center={center}
        // options={options}
        onClick={() => setSelected(null)}
      >
        <div key={wineryDetailInfo.id} className="google-maps-key">
          <Marker
            position={center}
            icon={{
              url: mapIcon,
              scaledSize: new window.google.maps.Size(30, 30),
            }}
            onClick={() => {
              setSelected(wineryDetailInfo);
            }}
          ></Marker>
        </div>

        {selected && (
          <InfoWindow
            position={center}
            options={{
              pixelOffset: new window.google.maps.Size(0, -40),
            }}
            onCloseClick={() => setSelected(null)}
          >
            <div>
              <div className="infoWindow-container">
                <img className="infoWindow-img" src={wine} alt="wine" />
                <div className="infoWindow-content">
                  <h4 className="infoWindow-title">{selected.company}</h4>
                  <h5 className="infoWindow-region">
                    Region:{selected.region}
                  </h5>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (
                        selected &&
                        selected.location &&
                        selected.location.lat &&
                        selected.location.lng
                      ) {
                        const destination = `${selected.location.lat},${selected.location.lng}`;
                        const apiKey =
                          "AIzaSyAP7_Dlc7qRZaIGbqEupCR3Kl8TLaNptOo";
                        window.open(
                          `https://www.google.com/maps/dir/?api=1&destination=${destination}&key=${apiKey}`
                        );
                      } else {
                        console.error(
                          "Selected location does not have valid latitude and longitude."
                        );
                      }
                    }}
                    className="exact-Address"
                  >
                    <img src={dicertionVector} alt="direction-vector" />
                    Directions
                  </button>
                </div>
              </div>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}
